import { simd as detectSimdSupport } from "wasm-feature-detect"
import wasmAddonModuleSimd from "./simd/liqaWasmAddonSimd"
import wasmSimd from "./simd/liqaWasmAddonSimd.wasm?url"
import wasmAddonModuleNoSimd from "./scalar/liqaWasmAddon"
import wasmNoSimd from "./scalar/liqaWasmAddon.wasm?url"
import type { WasmModule } from "./types"

let wasmModulePromise: Promise<WasmModule> | null = null

const getDependencies = async () => {
  const isSimdSupported = await detectSimdSupport()

  return {
    wasm: isSimdSupported ? wasmSimd : wasmNoSimd,
    wasmAddonModule: isSimdSupported ? wasmAddonModuleSimd : wasmAddonModuleNoSimd,
  }
}

export async function initWasmModule(): Promise<WasmModule> {
  if (!wasmModulePromise) {
    const { wasmAddonModule, wasm } = await getDependencies()
    wasmModulePromise = wasmAddonModule({
      locateFile(_: string) {
        return wasm
      },
    }) as Promise<WasmModule>
  }
  return wasmModulePromise
}
